import { Play, Square } from "lucide-react";
import { Button } from "@/components/ui/button";
import { frequencyLabel, presetName } from "@/lib/archiveCatalog";

export const ArchivePresets = ({ presets, audio }) => (
  <aside className="archive-presets" aria-label="Featured presets" data-testid="archive-presets">
    <div className="archive-section-heading"><h2 data-testid="archive-presets-title">LIBRARY_CONNECT</h2><span data-testid="archive-preset-count">{presets.length.toString().padStart(2, "0")}</span></div>
    <div className="archive-preset-list">
      {presets.map((preset, index) => {
        const active = audio.active?.id === preset.id;
        return <article className={`archive-preset ${active ? "is-active" : ""}`} key={preset.id} data-testid={`freq-card-${preset.id}`}>
          <span className="archive-preset-index" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
          <div className="archive-preset-body">
            <h3 data-testid={`preset-name-${preset.id}`}>{presetName(preset)}</h3>
            <p data-testid={`preset-carrier-${preset.id}`}>CARRIER <strong>{frequencyLabel(preset.carrier_hz)}</strong></p>
            <p data-testid={`preset-beat-${preset.id}`}>BEAT <strong>{frequencyLabel(preset.beat.beat_hz)}</strong><span className="archive-band">{preset.beat.name.replaceAll("_", " ")}</span></p>
          </div>
          <Button className="archive-button" variant="outline" size="sm" aria-pressed={active} aria-label={`${active ? "Stop" : "Use"} ${presetName(preset)}`} onClick={() => audio.preset(preset)} data-testid={`featured-preset-use-${preset.id}`}>{active ? <Square size={12} /> : <Play size={12} />}{active ? "STOP" : "USE"}</Button>
        </article>;
      })}
    </div>
    <p className="archive-preset-note" data-testid="archive-preset-duration">STEREO PRESETS · 5 MIN</p>
  </aside>
);